import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9dd45e10"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container d-flex" };
const _hoisted_2 = { class: "navbar-expand-md p-0 py-1" };
const _hoisted_3 = {
    class: "navbar-toggler pl-0",
    type: "button",
    "data-toggle": "collapse",
    "data-target": "#navbarLinks",
    "aria-controls": "navbarLinks",
    "aria-expanded": "false",
    "aria-label": "Toggle navigation",
    ref: "navMobileToggleButton"
};
const _hoisted_4 = {
    key: 0,
    class: "font6 strong pr-3 fc-brand_deep_blue"
};
const _hoisted_5 = {
    key: 1,
    class: "font6 strong pr-3"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_arrow_down" }, null, -1));
const _hoisted_7 = {
    class: "collapse navbar-collapse",
    id: "navbarLinks"
};
const _hoisted_8 = {
    class: "navbar-nav flex-wrap pt-2",
    ref: "mylinks"
};
const _hoisted_9 = ["href", "onClick"];
const _hoisted_10 = ["title", "href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("nav", {
        class: "staticPageNav subheader getsticky pt-3 pb-3",
        style: _normalizeStyle([{ "border-bottom": "4px solid #fff" }, { top: _ctx.headerHeight }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("nav", _hoisted_2, [
                _createElementVNode("button", _hoisted_3, [
                    (_ctx.mobile_nav_headline)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.mobile_nav_headline), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, "Weitere Infos")),
                    _hoisted_6
                ], 512),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav_elements, (nav_element, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: "nav-item mr-3 mb-3"
                            }, [
                                (_ctx.checkIfAnker(nav_element.target))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(["navEntry font-italic mr-3", { navEntryActive: _ctx.activeLinkIndex === index }]),
                                        href: index,
                                        onClick: ($event) => (_ctx.scrollToTheAnker(nav_element.target, index))
                                    }, _toDisplayString(nav_element.name), 11, _hoisted_9))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        class: _normalizeClass(["navLink mr-3", { activeLink: nav_element.active }]),
                                        title: nav_element.name,
                                        href: nav_element.target
                                    }, _toDisplayString(nav_element.name), 11, _hoisted_10))
                            ]));
                        }), 128))
                    ], 512)
                ])
            ])
        ])
    ], 4));
}
